import { createContext, useContext } from "react";

export const translations = {
  it: {
    nav: {
      home: "Home",
      about: "Chi siamo",
      activities: "Le nostre attività",
      help: "Cosa puoi fare tu",
      volunteering: "Volontariato",
      news: "News",
      contact: "Contatti",
      donate: "Dona ora",
    },
    hero: {
      kicker: "ONG · Madagascar",
      lines: ["Tu,", "per il", "Madagascar."],
      sub: "Dal 2023 portiamo acqua potabile, istruzione e opportunità nei villaggi del sud del Madagascar. Ogni gesto, anche il più piccolo, diventa un futuro più grande.",
      ctaPrimary: "Dona ora",
      ctaSecondary: "Scopri chi siamo",
      stats: [
        { value: "100+", label: "bambini a scuola" },
        { value: "5", label: "scuole realizzate" },
        { value: "70", label: "famiglie sostenute" },
      ],
      scroll: "Scorri per scoprire",
    },
    marquee: [
      "L'acqua è vita",
      "Istruzione per tutti",
      "Agricoltura sostenibile",
      "Infanzia protetta",
      "Solidarietà senza confini",
    ],
    about: {
      label: "Chi siamo",
      title: "Una promessa fatta di presenza, non di parole.",
      chapters: [
        {
          n: "01",
          title: "La nostra missione",
          text: "Portare dignità e opportunità nelle comunità rurali del sud del Madagascar, partendo dai bisogni essenziali: acqua, cibo, scuola.",
        },
        {
          n: "02",
          title: "Chi siamo",
          text: "Un gruppo di volontari italiani e malgasci uniti da un'idea semplice: nessuno si salva da solo. Lavoriamo fianco a fianco con i villaggi, mai al loro posto.",
        },
        {
          n: "03",
          title: "I nostri valori",
          text: "Trasparenza, rispetto della cultura locale e sostenibilità. Ogni euro raccolto arriva sul territorio e diventa un progetto concreto.",
        },
      ],
      imageCaption: "I bambini di Toliara — il nostro perché",
    },
    activities: {
      label: "Le nostre attività",
      title: "Quattro fronti, un solo obiettivo.",
      sub: "Interveniamo dove la vita comincia: acqua, scuola, terra e infanzia.",
      projects: [
        {
          key: "water",
          tag: "Acqua",
          title: "L'Acqua è Vita",
          text: "Pozzi, cisterne e sistemi di raccolta per garantire acqua potabile ai villaggi del sud.",
        },
        {
          key: "school",
          tag: "Istruzione",
          title: "Tutti a Scuola",
          text: "Mense, materiali e borse di studio per far sedere ogni bambino dietro un banco.",
        },
        {
          key: "agri",
          tag: "Agricoltura",
          title: "Effetto Serra",
          text: "Orti comunitari e formazione agricola per coltivare autonomia, non dipendenza.",
        },
        {
          key: "kids",
          tag: "Infanzia",
          title: "Crescere Protetti",
          text: "Un centro di accoglienza per i bambini vulnerabili di Toliara: un tetto, cure e un futuro.",
        },
      ],
    },
    help: {
      label: "Cosa puoi fare tu",
      title: "Il cambiamento inizia da te.",
      sub: "Tre modi concreti per stare al fianco del Madagascar. Scegli il tuo.",
      cards: [
        {
          key: "donate",
          title: "Dona ora",
          text: "Un contributo unico che si trasforma subito in acqua, pasti caldi e istruzione.",
          cta: "Fai una donazione",
        },
        {
          key: "adopt",
          title: "Adozione a distanza",
          text: "Fai studiare un bambino e regalagli un futuro diverso: un piccolo gesto, un legame che dura nel tempo.",
          cta: "Adozione a distanza",
        },
        {
          key: "volunteer",
          title: "Diventa volontario",
          text: "Dona il tuo tempo, in Italia o in Madagascar. Aiutaci a fare conoscere il nostro progetto.",
          cta: "Candidati",
        },
      ],
    },
    news: {
      label: "News",
      title: "Ultime dal Madagascar.",
      items: [
        {
          date: "12 Giu 2026",
          title: "Nuovo pozzo inaugurato nel villaggio di Ankililoaka",
          excerpt: "Oltre 900 persone hanno ora accesso all'acqua potabile a meno di dieci minuti da casa.",
        },
        {
          date: "28 Mag 2026",
          title: "La mensa scolastica di Tanambao compie un anno",
          excerpt: "365 giorni di pasti caldi per 420 bambini: la frequenza scolastica è cresciuta del 32%.",
        },
        {
          date: "9 Apr 2026",
          title: "Raccolta fondi “Un banco per tutti”: obiettivo raggiunto",
          excerpt: "Grazie a 612 donatori abbiamo finanziato 150 nuovi banchi per tre scuole rurali.",
        },
        {
          date: "17 Feb 2026",
          title: "Parte la seconda serra comunitaria di Betioky",
          excerpt: "Venticinque famiglie coltiveranno ortaggi tutto l'anno, anche nella stagione secca.",
        },
      ],
    },
    contact: {
      label: "Contatti",
      title: "Parliamone.",
      sub: "Domande, idee, collaborazioni: scrivici. Ti risponderemo entro 48 ore.",
      name: "Nome e cognome",
      email: "Email",
      message: "Il tuo messaggio",
      send: "Invia messaggio",
      sending: "Invio in corso…",
      success: "Messaggio inviato! Ti risponderemo presto.",
      error: "Qualcosa è andato storto. Riprova.",
      emailLabel: "Scrivici",
      officeLabel: "Le nostre sedi",
      offices: ["Toliara, Madagascar"],
    },
    donate: {
      title: "Fai una donazione",
      sub: "Scegli un importo. Pagamento sicuro con carta, PayPal o Google Pay tramite Stripe.",
      custom: "Altro importo",
      customPlaceholder: "Importo in € (min. 2)",
      submit: "Procedi al pagamento sicuro",
      processing: "Reindirizzamento a Stripe…",
      secure: "Transazione crittografata. You4Mada non memorizza i dati della tua carta.",
      methods: "Carta · PayPal · Google Pay",
      invalid: "Inserisci un importo valido (minimo 2 €).",
      error: "Impossibile avviare il pagamento. Riprova.",
      once: "Una volta",
      monthly: "Ogni mese",
      monthlyHint: "Diventa un sostenitore regolare: rinnovo automatico ogni mese, disdici quando vuoi.",
    },
    payment: {
      successTitle: "Grazie di cuore!",
      successText: "La tua donazione è andata a buon fine. Hai appena acceso una speranza in Madagascar.",
      verifying: "Stiamo confermando il tuo pagamento…",
      pendingText: "Pagamento ricevuto, in attesa di conferma finale da parte della banca.",
      cancelTitle: "Pagamento annullato",
      cancelText: "Nessun addebito è stato effettuato. Quando vorrai, saremo qui.",
      backHome: "Torna alla home",
      retry: "Riprova la donazione",
    },
    footer: {
      newsletterTitle: "Resta vicino al Madagascar",
      newsletterSub: "Una email al mese: storie, progetti e risultati. Niente spam.",
      placeholder: "La tua email",
      subscribe: "Iscriviti",
      subscribed: "Iscrizione confermata. Benvenuto/a!",
      error: "Inserisci un indirizzo email valido.",
      rights: "© 2026 You4Mada ONG — Tutti i diritti riservati.",
      tagline: "Tu, per il Madagascar.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About us",
      activities: "Our work",
      help: "What you can do",
      volunteering: "Volunteering",
      news: "News",
      contact: "Contact",
      donate: "Donate now",
    },
    hero: {
      kicker: "NGO · Madagascar",
      lines: ["You,", "for", "Madagascar."],
      sub: "Since 2023 we have been bringing clean water, education and opportunity to villages in southern Madagascar. Every gesture, even the smallest, becomes a bigger future.",
      ctaPrimary: "Donate now",
      ctaSecondary: "Discover who we are",
      stats: [
        { value: "100+", label: "children in school" },
        { value: "5", label: "schools built" },
        { value: "70", label: "families supported" },
      ],
      scroll: "Scroll to explore",
    },
    marquee: [
      "Water is life",
      "Education for all",
      "Sustainable farming",
      "Protected childhood",
      "Solidarity without borders",
    ],
    about: {
      label: "About us",
      title: "A promise made of presence, not words.",
      chapters: [
        {
          n: "01",
          title: "Our mission",
          text: "Bringing dignity and opportunity to rural communities in southern Madagascar, starting from essential needs: water, food, school.",
        },
        {
          n: "02",
          title: "Who we are",
          text: "A group of Italian and Malagasy volunteers united by a simple idea: no one is saved alone. We work side by side with the villages, never in their place.",
        },
        {
          n: "03",
          title: "Our values",
          text: "Transparency, respect for local culture and sustainability. Every euro raised reaches the field and becomes a concrete project.",
        },
      ],
      imageCaption: "The children of Toliara — our reason why",
    },
    activities: {
      label: "Our work",
      title: "Four fronts, one goal.",
      sub: "We act where life begins: water, school, land and childhood.",
      projects: [
        {
          key: "water",
          tag: "Water",
          title: "Water is Life",
          text: "Wells, tanks and harvesting systems to bring safe drinking water to southern villages.",
        },
        {
          key: "school",
          tag: "Education",
          title: "School for All",
          text: "Canteens, supplies and scholarships so every child can sit behind a desk.",
        },
        {
          key: "agri",
          tag: "Agriculture",
          title: "Greenhouse Effect",
          text: "Community gardens and farming training to grow autonomy, not dependence.",
        },
        {
          key: "kids",
          tag: "Childhood",
          title: "Growing Up Safe",
          text: "A shelter for vulnerable children in Toliara: a roof, care and a future.",
        },
      ],
    },
    help: {
      label: "What you can do",
      title: "Change starts with you.",
      sub: "Three concrete ways to stand by Madagascar. Choose yours.",
      cards: [
        {
          key: "donate",
          title: "Donate now",
          text: "A one-off gift that immediately turns into water, warm meals and education.",
          cta: "Make a donation",
        },
        {
          key: "adopt",
          title: "Sponsor a child",
          text: "Help a child study and gift them a different future: a small gesture, a bond that lasts.",
          cta: "Sponsor a child",
        },
        {
          key: "volunteer",
          title: "Become a volunteer",
          text: "Give your time, in Italy or in Madagascar. Help us spread the word about our project.",
          cta: "Apply now",
        },
      ],
    },
    news: {
      label: "News",
      title: "Latest from Madagascar.",
      items: [
        {
          date: "Jun 12, 2026",
          title: "New well inaugurated in the village of Ankililoaka",
          excerpt: "Over 900 people now have drinking water less than ten minutes from home.",
        },
        {
          date: "May 28, 2026",
          title: "The Tanambao school canteen turns one",
          excerpt: "365 days of warm meals for 420 children: attendance is up 32%.",
        },
        {
          date: "Apr 9, 2026",
          title: "“A desk for everyone” fundraiser: goal reached",
          excerpt: "Thanks to 612 donors we funded 150 new desks for three rural schools.",
        },
        {
          date: "Feb 17, 2026",
          title: "Work begins on Betioky's second community greenhouse",
          excerpt: "Twenty-five families will grow vegetables all year round, even in the dry season.",
        },
      ],
    },
    contact: {
      label: "Contact",
      title: "Let's talk.",
      sub: "Questions, ideas, partnerships: write to us. We reply within 48 hours.",
      name: "Full name",
      email: "Email",
      message: "Your message",
      send: "Send message",
      sending: "Sending…",
      success: "Message sent! We'll get back to you soon.",
      error: "Something went wrong. Please try again.",
      emailLabel: "Write to us",
      officeLabel: "Our offices",
      offices: ["Toliara, Madagascar"],
    },
    donate: {
      title: "Make a donation",
      sub: "Choose an amount. Secure payment by card, PayPal or Google Pay via Stripe.",
      custom: "Custom amount",
      customPlaceholder: "Amount in € (min. 2)",
      submit: "Proceed to secure payment",
      processing: "Redirecting to Stripe…",
      secure: "Encrypted transaction. You4Mada never stores your card details.",
      methods: "Card · PayPal · Google Pay",
      invalid: "Please enter a valid amount (minimum €2).",
      error: "Unable to start the payment. Please try again.",
      once: "One-time",
      monthly: "Every month",
      monthlyHint: "Become a regular supporter: automatic renewal every month, cancel anytime.",
    },
    payment: {
      successTitle: "Thank you from the heart!",
      successText: "Your donation was successful. You just lit a spark of hope in Madagascar.",
      verifying: "Confirming your payment…",
      pendingText: "Payment received, awaiting final confirmation from the bank.",
      cancelTitle: "Payment cancelled",
      cancelText: "No charge was made. Whenever you're ready, we'll be here.",
      backHome: "Back to home",
      retry: "Try donating again",
    },
    footer: {
      newsletterTitle: "Stay close to Madagascar",
      newsletterSub: "One email a month: stories, projects and results. No spam.",
      placeholder: "Your email",
      subscribe: "Subscribe",
      subscribed: "Subscription confirmed. Welcome!",
      error: "Please enter a valid email address.",
      rights: "© 2026 You4Mada NGO — All rights reserved.",
      tagline: "You, for Madagascar.",
    },
  },
};

export const authTranslations = {
  it: {
    login: "Accedi",
    logout: "Esci",
    myDonations: "Le mie donazioni",
    donorTitle: "La tua area donatore",
    donorSub: "Qui trovi il riepilogo del tuo sostegno a You4Mada.",
    member: "Donatore You4Mada",
    noDonations: "Ancora nessuna donazione registrata con questa email.",
    noDonationsCta: "Fai la tua prima donazione",
    statusPaid: "Completata",
    statusPending: "In attesa",
    statusFailed: "Non riuscita",
    loginPromptTitle: "Accedi per vedere le tue donazioni",
    loginPromptText: "Usa il tuo account Google: ci vuole un secondo.",
    loginWithGoogle: "Accedi con Google",
    backHome: "Torna alla home",
    totalDonated: "Totale donato",
    donationsCount: "Donazioni",
    chat: {
      title: "Assistente You4Mada",
      greeting: "Ciao! Sono l'assistente di You4Mada. Chiedimi pure dei nostri progetti in Madagascar, delle donazioni o di come diventare volontario.",
      placeholder: "Scrivi un messaggio…",
      error: "Ops, qualcosa è andato storto. Riprova.",
      openLabel: "Apri la chat",
    },
  },
  en: {
    login: "Sign in",
    logout: "Sign out",
    myDonations: "My donations",
    donorTitle: "Your donor area",
    donorSub: "Here is a summary of your support to You4Mada.",
    member: "You4Mada donor",
    noDonations: "No donations recorded with this email yet.",
    noDonationsCta: "Make your first donation",
    statusPaid: "Completed",
    statusPending: "Pending",
    statusFailed: "Failed",
    loginPromptTitle: "Sign in to see your donations",
    loginPromptText: "Use your Google account: it takes a second.",
    loginWithGoogle: "Sign in with Google",
    backHome: "Back to home",
    totalDonated: "Total donated",
    donationsCount: "Donations",
    chat: {
      title: "You4Mada Assistant",
      greeting: "Hi! I'm the You4Mada assistant. Ask me about our projects in Madagascar, donations or how to volunteer.",
      placeholder: "Type a message…",
      error: "Oops, something went wrong. Please try again.",
      openLabel: "Open chat",
    },
  },
};

export const LanguageContext = createContext({
  lang: "it",
  setLang: () => {},
  t: translations.it,
});

export const useLang = () => useContext(LanguageContext);
